import { render, staticRenderFns } from "./BetgameInfo.vue?vue&type=template&id=c499477a&scoped=true"
import script from "./BetgameInfo.vue?vue&type=script&lang=js"
export * from "./BetgameInfo.vue?vue&type=script&lang=js"
import style0 from "./BetgameInfo.vue?vue&type=style&index=0&id=c499477a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c499477a",
  null
  
)

export default component.exports